class ScheduledTask {
    private scheduler: NodeJS.Timer;

    constructor(timeInterval: number, checkFunction: () => boolean, callback: () => void) {

        this.scheduler = setInterval(() => {
            if (checkFunction()) {
                callback();
            }
        }, timeInterval);
    }

    cancelScheduler(): void {
        clearInterval(this.scheduler);
    }
}

export default ScheduledTask;
